<script lang="ts">
  import { get, Readable, derived, writable, readable } from "svelte/store";
  import { FileMgr } from "../stores/FileMgr";

  import Path from "../scripts/Path";
  import { onMount } from "svelte";
  import FinderIcon from "../components/FinderIcon.svelte";
  import { addLog } from "../stores/LoggerStore";
  import { randomId } from "../scripts/utils";
  import ProcMgr, { resetSaved } from "../stores/ProcMgr";
  import type { Dir } from "../scripts/FileTypes";
  import SettingsMgr from "../stores/SettingsMgr";
  import type { Theme } from "../scripts/WinTypes";
  let deskElem: HTMLElement, backBtn: HTMLElement, forwardBtn: HTMLElement;
  const procmgr = ProcMgr.getInstance();
  const filemgr = FileMgr.getInstance();
  let currentPath = "~/";
  let imageElem: HTMLElement,
    broomElem: HTMLElement,
    imgWrapperElem: HTMLElement;
  let backgroundImg = "/imgs/wall2.jpg",
    broomImg = "/imgs/broom.svg";
  let winWidth, winHeight;

  //Theme ============================================================
  const _theme = SettingsMgr.getInstance().theme;
  const themeWatcher = (theme: Theme) => {
    if (!deskElem) {
      return;
    }
    const c = theme.colors;
    deskElem.style.setProperty("color", c["1"]);
    imgWrapperElem.style.setProperty("background-color", c["1"]);
    return theme.colors;
  };
  $: _colors = themeWatcher($_theme);

  const _setDir = (dirPath: string) => {
    return filemgr.findDirReadable(new Path(dirPath));
  };
  // $: _dir = filemgr.findDirReadable(new Path(winProps.data.path));
  // $: _dir = _setDir(currentPath);
  $: _dir = filemgr.findDirReadable(new Path("~/"));
  const getNodes = (dirs: Dir) => {
    const retval = [...dirs.dirs, ...dirs.files];
    console.log("getNodes:", retval);
    if (!_dir) {
      return readable<(Dir | File)[]>([]);
    }
    return derived(_dir, (dir) => [...dir?.dirs, ...dir?.files]);
  };
  // $: nodes = getNodes($_dir);
  $: nodes = derived(_dir, (dir) => [...dir?.dirs, ...dir?.files]);

  const menuId = randomId();
  const closeFinderAction = (e) => {
    e.preventDefault();
    document.querySelector(`#${menuId}`)?.remove();
  };
  const openFinderAction = (e) => {
    if (document.querySelector(`#${menuId}`)) {
      return;
    }
    const menuElem = document.createElement("span") as HTMLElement;
    menuElem.id = menuId;
    menuElem.innerText = `Reset bread`;
    menuElem.style.backgroundColor = "#333";
    menuElem.style.opacity = "0.9";
    menuElem.style.color = "#dbdbdb";
    menuElem.style.lineHeight = "1.8rem";
    menuElem.style.padding = "10px";
    menuElem.style.width = "160px";
    menuElem.style.height = "210px";
    menuElem.style.position = "fixed";
    menuElem.style.left = `${e.pageX}px`;
    menuElem.style.top = `${e.pageY}px`;
    menuElem.style.cursor = "pointer";
    menuElem.addEventListener("focusout", (_e) => {
      const thisElem = _e.target as HTMLElement;
      console.log("focus out");
      thisElem.parentElement.removeChild(thisElem);
    });
    menuElem.addEventListener("mousedown", (_e) => {
      procmgr.add("resetbread");
    });
    menuElem.removeEventListener;
    deskElem.appendChild(menuElem);
    addLog("Right clicked");
  };

  //   const moveBackground = (e) => {
  //     //parallax background
  //     e.preventDefault();
  //     console.log(`x:${e.pageX} y:${e.pageY}`);
  //     const maxPercentage = 2; //10percent
  //     const t = `translate(calc(-50% + ${
  //       (e.pageX / winWidth - 0.5) * maxPercentage
  //     }%), calc(-50% + ${
  //       (e.pageY / winHeight - 0.5) * maxPercentage
  //     }%)) scale(1.2)`;
  //     imageElem.style.transform = t;
  //   };

  onMount(() => {
    _colors = themeWatcher($_theme);
    console.log("Desktop mounted");
    console.log(_dir);
    // deskElem?.addEventListener("click", handleFileAction);
    window.oncontextmenu = () => false;
    deskElem?.addEventListener("mousedown", closeFinderAction);
    deskElem?.addEventListener("contextmenu", openFinderAction);
  });
</script>

<svelte:window bind:innerWidth={winWidth} bind:innerHeight={winHeight} />

<div id="desktop" class="container" bind:this={deskElem}>
  <img
    id="broom-image"
    class="broom-image"
    src={broomImg}
    alt="Broom effect"
    bind:this={broomElem}
  />
  <div class="bg-image-wrapper">
    <img
      class="bg-image"
      src={backgroundImg}
      alt="Desktop background"
      bind:this={imageElem}
    />
    <div class="behind-image" bind:this={imgWrapperElem} />
  </div>
  <div class="icon-container">
    <!-- <DirView dir={$_dir} /> -->
    {#each $nodes as node (node.node.id)}
      <!-- {#each $nodes as node} -->
      <!-- Nodes : {node.node.path.path}, type : {node.node.type} -->
      <!-- {node.node.id}<br /> -->
      <FinderIcon fileNode={node.node} />
    {/each}
  </div>
</div>
<div class="css-keeper broom-image active" />

<style>
  .container {
    position: relative;
    width: 100%;
    height: 100%;
    color: #333;
  }
  .broom-image {
    opacity: 0;
    position: fixed;
    top: 20%;
    left: 25%;
    width: 50%;
    height: 50%;
    object-fit: contain;
    object-position: center center;
    transition: 0.3s;
    z-index: -1;
  }
  .broom-image.active {
    opacity: 1;
    display: block;
    animation-duration: 1s;
    animation-name: brooming;
    z-index: 1001;
  }
  .behind-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.5;
    mix-blend-mode: multiply;
    mix-blend-mode: saturation;
    mix-blend-mode: color-burn;

    opacity: 0.2;
    mix-blend-mode: hard-light;

    opacity: 0.3;
    mix-blend-mode: overlay;
  }
  @keyframes brooming {
    from {
      transform: translateY(0px) rotate(0deg);
    }
    25% {
      transform: translateY(200px) rotate(-90deg);
    }
    50% {
      transform: translateY(130px) rotate(0deg);
    }
    75% {
      transform: translateY(200px) rotate(-90deg);
    }
    to {
      transform: translateY(0px) rotate(0deg);
    }
  }
  .bg-image-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  .bg-image {
    /* position: absolute; */
    width: 100%;
    height: 100%;
    /* top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(1.2); */
    object-fit: cover;
    object-position: center center;
    /* transition: 0.1s; */
    mix-blend-mode: multiply;
  }
  .icon-container {
    position: absolute;
    top: 0;
    left: 0;
    margin: 0;
    box-sizing: border-box;
    display: grid;
    width: 100%;
    height: 100%;
    padding: 5px;
    gap: 15px;
    grid-auto-flow: column;
    grid-template-columns: repeat(auto-fill, 120px);
    grid-template-rows: repeat(auto-fill, 140px); /* Your number of rows */
    direction: rtl;
  }
  .css-keeper.broom-image.active {
    display: none;
    z-index: -1;
  }
</style>
